const text_type_choices = [
    { id: 'Resumo', name: 'Resumo' },
    { id: 'Google Ads', name: 'Google Ads' },
    { id: 'Facebook Ads', name: 'Facebook Ads' },
    { id: 'Métricas', name: 'Métricas' },
    { id: 'Simplificado', name: 'Simplificado' },
    { id: 'Outros', name: 'Outros' },
]

export default text_type_choices